import React, { useState, useEffect } from "react";
import { Container, Grid, Typography, Card, CardContent, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import "../CSS/About.css";
import Footer from "./Footer";

const RootContainer = styled(Container)(({ theme }) => ({
  color: "#ffffff",
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "40px",
}));

const AboutCard = styled(Card)({
  backgroundColor: "transparent",
  color: "#ffffff",
  padding: "20px",
  textAlign: "left",
  maxWidth: "800px",
  margin: "auto",
});

const CircularCard = styled(Card)({
  backgroundColor: "rgba(52, 39, 153, 0.3)",
  color: "#ffffff",
  borderRadius: "50%",
  width: "300px",
  height: "300px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0px 4px 15px rgba(29, 7, 70, 0.67)",
  border: "1px solid rgba(29, 7, 70, 0.67)",
  textAlign: "center",
  padding: "10px",
  fontFamily: "'Inter', sans-serif",
  transition: "box-shadow 0.3s ease-in-out, background 0.3s ease-in-out",
  '&:hover': {
    boxShadow: "0px 0px 20px rgba(100, 255, 218, 0.9)",
    background: "rgba(5, 75, 58, 0.3)",
  },
});

const CircularCard2 = styled(Card)({
  backgroundColor: "rgba(52, 39, 153, 0.3)",
  color: "#ffffff",
  borderRadius: "50%",
  width: "300px",
  height: "300px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0px 4px 15px rgba(29, 7, 70, 0.67)",
  border: "1px solid rgba(29, 7, 70, 0.67)",
  textAlign: "center",
  padding: "10px",
  fontFamily: "'Inter', sans-serif",
  transition: "box-shadow 0.3s ease-in-out, background 0.3s ease-in-out",
  '&:hover': {
    boxShadow: "0px 0px 20px rgba(116, 25, 191, 0.9)",
    background: "rgba(46, 12, 73, 0.3)",
  },
});




const AboutUs = () => {
  const [showText, setShowText] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowText(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  const descriptions = [
    "To be a global leader in providing innovative solutions that improve lives and create sustainable growth for all stakeholders.",
    "Our mission is to consistently deliver high-quality services that exceed customer expectations and foster long-lasting relationships.",
    "We uphold the highest standards of integrity, teamwork, and excellence, ensuring every project we undertake reflects these values."
  ];

  const additionalDescriptions = [
    "Trust is the foundation of all our relationships, ensuring transparency and reliability in everything we do.",
    "We foster a strong team spirit, encouraging collaboration and mutual respect to achieve shared success.",
    "Customer centricity is at the heart of our business, striving to exceed expectations with every interaction."
  ];

  return (
    <RootContainer>
      {!showText ? (
        <div className="container">
          {[...Array(4)].map((_, rowIndex) => (
            <div key={rowIndex} className="flex">
              {[...Array(4)].map((_, i) => (
                <div key={i} className="cube">
                  <div className="wall front"></div>
                  <div className="wall back"></div>
                  <div className="wall left"></div>
                  <div className="wall right"></div>
                  <div className="wall top"></div>
                  <div className="wall bottom"></div>
                </div>
              ))}
            </div>
          ))}
        </div>
      ) : (
        <>
          <AboutCard>
            <CardContent>
              <Typography variant="h3" gutterBottom sx={{ fontWeight: "bold", color: "#bdb6a0", fontFamily: "'Inter', sans-serif" }}>
                About Us
              </Typography>
              <Typography variant="body1" sx={{ fontSize: "1.2rem", color: "#d1d5db" }}>
                Welcome to NexExcellency! We are committed to delivering exceptional services and innovative solutions that make a real difference in the lives of our customers and communities.
              </Typography>
              <Typography variant="body1" sx={{ fontSize: "1.2rem", color: "#d1d5db",marginTop:"15px" }}>
                Our mission is to set new standards in our industry through quality, reliability, and a customer-first approach.
              </Typography>
            </CardContent>
          </AboutCard>


          <Grid container spacing={4} justifyContent="center" sx={{ marginTop: "20px" }}>
            {["Vision", "Mission", "Values"].map((title, index) => (
              <Grid item key={index}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <CircularCard>
                  <CardContent>
                    <Typography variant="h4" sx={{ fontWeight: "bold", color: "#bdb6a0" }}>
                      {hoveredIndex === index ? "" : title}
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: "1rem", color: "#d1d5db" }}>
                      {hoveredIndex === index ? descriptions[index] : ""}
                    </Typography>
                  </CardContent>
                </CircularCard>
              </Grid>
            ))}
          </Grid>
<Typography
  variant="h3"
  sx={{
    fontWeight: "bold",
    textAlign: "center",
    marginTop: "50px",
    color: "#bdb6a0",
    marginBottom: "5px",
    transition: "0.3s", // Smooth transition effect
    "&:hover": {
      textShadow: "0 0 10px #bdb6a0, 0 0 20px #bdb6a0, 0 0 30px #ffffff", // Glow effect
    },
  }}
>
  Core Beliefs
</Typography>


          <Typography variant="body1" sx={{ fontSize: "1.2rem", color: "#d1d5db",textAlign:"center",  maxWidth: "800px",
  margin: "auto",padding:"20px"}}>
          At NexExcellency, we embrace continuous improvement, innovation, and bold ideas, constantly challenging the status quo to deliver smarter solutions and value to our stakeholders.
          </Typography>

          <Grid container spacing={4} justifyContent="center" sx={{ marginTop: "40px" }}>
            {["Trust", "Team Spirit", "Customer Centricity"].map((title, index) => (
              <Grid item key={index}
                onMouseEnter={() => setHoveredIndex(index + 3)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <CircularCard2>
                  <CardContent>
                    <Typography variant="h4" sx={{ fontWeight: "bold", color: "#bdb6a0" }}>
                      {hoveredIndex === index + 3 ? "" : title}
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: "1rem", color: "#d1d5db" }}>
                      {hoveredIndex === index + 3 ? additionalDescriptions[index] : ""}
                    </Typography>
                  </CardContent>
                </CircularCard2>
              </Grid>
            ))}
          </Grid>




            <Footer />





        </>
      )}
    </RootContainer>
  );
};

export default AboutUs;
